<template lang="pug">
  v-container
    v-stepper(v-model='e6' vertical)
      v-container
        v-layout.justify-space-between.align-center
          h2 Cotizacion
          
          v-flex(sm4)
            v-img(:src='Customers.logoUrl' )
      v-stepper-step(:complete='e6 > 1' step='1' @click='e6 = 1')
        | Datos personales
      v-stepper-content(step='1')
        v-flex(xs12 v-if="Datos.provedores.filter(item=>$route.params.idProveedor == item.key )[0]")
          v-text-field(v-model='Datos.provedores.filter(item=>$route.params.idProveedor == item.key )[0].name' label='Provedor' disabled )
          v-text-field(v-model='Datos.provedores.filter(item=>$route.params.idProveedor == item.key )[0].phone' label='Celular' disabled )
          v-text-field(v-model='Datos.provedores.filter(item=>$route.params.idProveedor == item.key )[0].address' label='Dirección' disabled )
          v-text-field(v-model='Datos.provedores.filter(item=>$route.params.idProveedor == item.key )[0].email' label='Email' disabled )
          v-text-field(v-model='Datos.correo_adicional' label='Correo adicional')
        v-btn(color='primary' @click='e6 = 2') Continuar
        v-btn(text='') Cancelar
      v-stepper-step(:complete='e6 > 2' step='2' @click='e6 = 2') Productos
      v-stepper-content(step='2')
        small A continuación realice su propuesta indicando el precio(Inc. IGV) de los elementos indicados. 
        v-card-text
          v-data-table( hide-default-footer :headers="selectedItemsHeaders" :items="Datos.items"  )
            template( v-slot:item.numeracion='{item}' )
              span {{ Datos.items.indexOf(item) + 1 }}
            template( v-slot:item.descripcion='{item}')
              span {{ item.codigo }} {{ item.descripcion }}
            template( v-slot:item.cantidad='{item}')
              v-text-field( type='number' required v-model.number='item.cantidad' disabled )
            template( v-slot:item.valor_unitario='{item}')
              v-text-field( type='number' required v-model.number='item.valor_unitario')
            template( v-slot:item.tipo_de_igv='{item}')
              v-btn(v-model='item.tipo_de_igv' outlined color='primary' @click='item.tipo_de_igv = item.tipo_de_igv === 1 ? 8 : 1')
                span {{ item.igv | number }} 
                v-icon(small v-if='item.tipo_de_igv === 8') fas fa-plus
            template( v-slot:item.descuento='{item}')
              v-text-field( type='number' required v-model.number='item.descuento' )

              span( :v-html='item.igv = toNumber((item.tipo_de_igv === 1) ? item.valor_unitario * 0.18 * item.cantidad : 0)'  )
              span( :v-html='item.precio_unitario = toNumber((item.tipo_de_igv === 1) ? item.valor_unitario * 1.18 : item.valor_unitario)' )
              span( :v-html='item.subtotal = toNumber(item.cantidad * item.valor_unitario - item.descuento) ' v-show='false' )
              span( :v-html='item.total = toNumber((item.tipo_de_igv === 1) ? ( item.cantidad * item.valor_unitario - item.descuento ) * 1.18 : item.cantidad * item.valor_unitario - item.descuento) ' v-show='false' )
        v-btn(color='primary' @click='e6 = 3') Continuar
        v-btn(text='') Cancelar
      v-stepper-step(:complete='e6 > 3' step='3' @click='e6 = 3') Calidad
      v-stepper-content(step='3')
        v-text-field(v-model='Datos.calidad' label='Certificación de Calidad')
        v-text-field( v-model='Datos.garantia'  label='Especificar garantía')
        v-btn(color='primary' @click='e6 = 4') Continuar
        v-btn(text='') Cancelar
      v-stepper-step(:complete='e6 > 4' step='4' @click='e6 = 4') Condiciones de pago 
      v-stepper-content(step='4')
        v-select( v-model ='Datos.medio_de_pago' :items='Medio_de_pago_record' item-text='description' item-value= 'description' return-object label='Medio de pago'  )
        v-select( v-model='Datos.condiciones_de_pago' :items='condiciones_de_pago'  item-text='label' item-value='value' label='Condición de pago' )
        v-select( v-model='Datos.tipo_de_cambio' :items='lista_de_monedas' item-text='label' item-value='value' label='Moneda' )
        v-btn(color='primary' @click='e6 = 5') Continuar
        v-btn(text='') Cancelar
      v-stepper-step(:complete='e6 > 5' step='5' @click='e6 = 5') Observaciones
      v-stepper-content(step='5') 
        v-container
          v-col
            v-row
              v-switch(v-model='Datos.envalaje' label='¿El producto será correctamente envalado?' class='ma-2')
            v-row
              v-switch(v-model='Datos.envio' label='¿Incluye envío?' class='ma-2')
            v-row
              v-text-field(v-model='Datos.Observaciones' label='Observaciones')
            v-row
              adjuntar_documento(@getUrl="val => Datos.archivo_adjunto = val")
              v-spacer
              v-btn( :color='Customers.color' dark @click='enviar_cotizacion({idCotizacion: $route.params.idCotizacion, customerName: $route.params.customerName , idProveedor: $route.params.idProveedor})'  ) Enviar 
        
</template>
<script>  
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
import lista_de_monedas from '@/jsons/tipo_monedas.json'
import { stat } from 'fs';
  export default {
    data: () => ({
       e6: 1,
       condiciones_de_pago: [
         {label: 'Contado', value: 0},
         {label: '7 días', value: 7},
         {label: '15 días', value: 15},
         {label: '30 días', value: 30},
         {label: '45 días', value: 45},
         {label: '60 días', value: 60},

       ],
       selectedItemsHeaders: [
      { text: 'Nº', value: 'numeracion',  },
      { text: 'Descripción',  value: 'descripcion'},
      { text: 'U. M.', value: 'unidad_de_medida'},
      { text: 'Cantidad', value: 'cantidad' },
      { text: 'Valor U.', value: 'valor_unitario' },
      { text: 'IGV', value: 'tipo_de_igv'},
      { text: 'Descuento (S/)', value: 'descuento'},
      { text: 'SubTotal', value: 'subtotal'},
      { text: 'Total', value: 'total'},
    ],
    record: [],
    Registro_de_Cotizaciones:[],
    lista_de_monedas,
  }),
   created (){

    this.Seleccionar_consumidor(this.$route.params.customerName).then(async()=>{
      this.Activar_db()  
      await this.Obtener_cotización(this.$route.params.idCotizacion)
    })
  },
  methods: {
    ...mapActions({
      Obtener_cotización: 'Cotizaciones/get',
      Seleccionar_consumidor: 'Customers/setCustomer',
      Activar_db: 'Customers/getAllDocuments',
      enviar_cotizacion: 'Cotizaciones/enviar_cotizacion'
    }),
  },
  computed: {
    ...mapState({
       Datos: state=> state.Cotizaciones.datos,
       Customers: state=> state.Customers.data,
       Data: state=> state.PaymentMethods.data,
    }),
     ...mapGetters({
      Medio_de_pago_record: 'PaymentMethods/record',
    })
  },
  components:{
    adjuntar_documento: ()=>import('../../componentes/adjuntar_archivos')
  }
}
</script>
